import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-frontend',
  templateUrl: './business-frontend.component.html',
  styleUrls: ['./business-frontend.component.scss']
})
export class BusinessFrontendComponent implements OnInit {
  data={
    image:"/assets/images/section-3.jpg",
    icon:"storefront",
    firstText:"Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
    textTitle:"Conviertete en usuario business",
    textTitle2:"Proporcionamos las herramientas y plataforma para que puedas pertenecer a una academia y dictar un curso",
    color:"#72CFD6"
  }
  constructor() { }

  ngOnInit(): void {
  }

}
